import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as XLSX from 'xlsx';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { Config } from '../../models/config';
import { Message } from '../../models/domain';

@Component({
  selector: 'app-excel-uploader',
  templateUrl: './excel-uploader.component.html',
  styleUrls: ['./excel-uploader.component.scss']
})
export class ExcelUploaderComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() apiUrl?: string;
  @Input() file?: string;
  @Input() format?: boolean;
  @Input() template?: string;
  @Input() headerLabels?: string[];
  @Output() onUpload?: EventEmitter<any> = new EventEmitter();
  @Output() onDownload?: EventEmitter<any> = new EventEmitter();

  public name = '';
  public request: FormData;
  private columns: string[] = [];

  constructor(
    private authService: AuthService,
    private httpClient: HttpClient,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
  }
  public onFileSelect(e) {
    this.request = new FormData();
    this.name = e?.target?.files[0]?.name;
    this.request.append(`${this.file}`, e?.target?.files[0]);
    this.getExcelColumns(event).subscribe({
      next: (columns: string[]) => {
        this.columns = columns;
      },
      error: (error: any) => {
        this.commonService.setToastr(400, 'The selected excel template is invalid!');
      }
    });
  }

  public upload() {
    if (this.request && this.name) {
      if (this.columns, this.headerLabels) {
        // const headers = new HttpHeaders({
        //     "Content-Type":'multipart/form-data'
        // });
        this.httpClient.post(this.apiUrl, this.request).subscribe((resp: Message) => {
          this.resetFileInput();
          this.request = null;
          this.name = "";
          this.onUpload.emit(resp);
          if (resp.failed) {
            this.commonService.setToastr(500, resp.text);
          } else {
            this.commonService.setToastr(200, resp.text);
          }
        });
      } else this.commonService.setToastr(400, 'The selected excel template is invalid!');
    } else this.commonService.setToastr(401, 'Please select a file to proceed with the excel upload.');
  }
  
  private resetFileInput() {
    this.fileInput.nativeElement.value = '';
    this.name = '';
  }
  public download() {
    if (this.format) window.open(this.template);
    else this.onDownload.emit(true);
  }

  private validateColumns(columns: any[], labels: any[]): boolean {
    columns = columns.map(l => l = this.removeSpace(l).toLowerCase());
    labels = labels.map(l => l = this.removeSpace(l).toLowerCase());
    if (columns.length !== labels.length) {
      return false;
    }
    for (let i = 0; i < columns.length; i++) {
      if (columns[i] !== labels[i]) {
        return false;

      }
    }
    return true;
  }

  private removeSpace(string) {
    return string.replace(" ", "");
  }

  public getExcelColumns(event: any) {
    return new Observable((columns: Observer<any>) => {
      const target: DataTransfer = <DataTransfer>(event.target);
      if (target.files.length !== 1) {
        throw new Error('Cannot use multiple files');
      }
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files[0]);
      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        columns.next(data[0]);
      };
    });
  }

}
